<script>
    import { onMount } from 'svelte';

    export let url_root = '/';
    export let nces_id;
    export let url;
    export let slug;
    export let h2 = '';
    export let guff = '';

    let isCollapsed = true;
    let formSubmitted = null;

    let privacy;
    let screen_width;
    let screen_height;
    let sender = {
        name: '',
        email: '',
        relationship: '',
    };
    let description = '';

    const toggleCollapse = () => {
        isCollapsed = !isCollapsed;
    };

    const handleKeydown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            toggleCollapse();
            event.preventDefault();
        }
    };

    const submitForm = async (event) => {
        const url = `${window.location.origin}${url_root}api/data-errors`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    nces_id,
                    url,
                    slug,
                    sender,
                    description,
                    screen_width,
                    screen_height,
                    privacy,
                }),
            });
            await response.json();
            formSubmitted = response.status;
        } catch (err) {
            formSubmitted = 500;
            console.error(err);
        }
    };
    onMount(() => {
        screen_width = window.screen.width;
        screen_height = window.screen.height;
    });
</script>

<h2>{h2}</h2>

<p>
    {guff}
</p>

{#if isCollapsed}
    <button class="btn" on:click={toggleCollapse}>Contact Us</button>
{/if}

<div class="form {isCollapsed ? 'hidden' : ''}">
    {#if formSubmitted != 201}
        <form on:submit|preventDefault={(event) => submitForm(event)}>
            <input type="hidden" name="nces_id" value={nces_id} readonly />
            <input type="hidden" name="url" value={url} readonly />
            <input type="hidden" name="slug" value={slug} readonly />
            <input type="hidden" name="screen_width" value={screen_width} readonly />
            <input type="hidden" name="screen_height" value={screen_height} readonly />

            <!-- Name -->
            <input bind:value={sender.name} type="text" name="name" placeholder="Your name" required />

            <!-- Email -->
            <input
                bind:value={sender.email}
                type="email"
                inputmode="email"
                name="email"
                placeholder="Your email address"
                required
            />

            <!-- Relationship to school -->
            <select bind:value={sender.relationship}>
                <option value="" selected disabled>What is your relationship to the school?</option>
                {#each ['Staff', 'Teacher', 'Parent', 'Student', 'Alum', 'Other'] as r}
                    <option value={r}>{r}</option>
                {/each}
            </select>

            <!-- Description -->
            <textarea bind:value={description} name="description" placeholder="Describe the error" rows="10" required
            ></textarea>

            <label class="legal">
                <input bind:value={privacy} name="privacy" type="checkbox" required />
                <span>
                    Agree to our <a href="https://www.propublica.org/legal/">Privacy Policy</a>
                </span>
            </label>

            {#if formSubmitted == null}
                <div class="form-controls">
                    <button class="right">Submit</button>
                </div>
            {:else}
                <p class="error">
                    Something went wrong. Please email <a href="mailto:privateschools@propublica.org"
                        >PrivateSchools@propublica.org</a
                    > instead.
                </p>
            {/if}
        </form>
    {:else if formSubmitted == 201}
        <p class="success">Thanks for your submission!</p>
    {/if}
</div>

<style lang="scss">
    .hidden {
        display: none;
    }

    .form-controls {
        text-align: right;
    }

    .form {
        margin: auto;
        margin-left: 0;

        @media only screen and (width >= 48em) {
            max-width: 24em;
        }
    }

    .right {
        text-align: right;
    }

    .legal {
        display: flex;
        color: var(--gray-50);
        font-size: var(--scale-2);
        gap: var(--spacing-2);

        a {
            color: inherit;
            text-decoration: underline !important;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .error {
        color: #da352b;

        a {
            color: inherit;
            text-decoration: underline !important;

            &:hover {
                text-decoration: none !important;
            }
        }
    }

    button {
        border-radius: 4px;
        background-color: #006997;
        color: white;
        font-size: var(--scale-1);
        font-weight: normal;
    }

    select,
    input[type='text'],
    input[type='email'],
    textarea {
        display: block;
        width: 100%;
        border: 1px solid var(--color-text-body);
        border-radius: 4px;
        margin: var(--spacing0) 0;

        &[readonly] {
            background-color: var(--gray-3);
            color: var(--gray-30);
        }
    }

    textarea {
        resize: vertical;
    }
</style>
